import { motion } from 'framer-motion'
import { NavLink } from 'react-router-dom'

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2 } },
}

const itemVariants = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } },
}

export default function ComingSoon() {
  return (
    <motion.div
      className="flex flex-col items-center justify-center text-center gap-6 py-24 px-10"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.p
        className="font-halyard text-[12px] font-normal tracking-[3px] uppercase text-[#1B1F24] opacity-50"
        variants={itemVariants}
      >
        Coming Soon
      </motion.p>

      <motion.div className="flex flex-col items-center gap-3" variants={itemVariants}>
        <h2 className="font-halyard font-normal text-[40px] lg:text-[60px] leading-[1.1] uppercase text-[#1B1F24]">
          We&apos;re crafting this page
        </h2>
        <p className="font-halyard font-light text-[18px] leading-relaxed text-[#1B1F24] opacity-60 max-w-[480px]">
          This content is being prepared. Check back shortly — it will be ready soon.
        </p>
      </motion.div>

      <motion.hr
        className="w-[60px] border-t border-[#1B1F24] opacity-20"
        variants={itemVariants}
      />

      <motion.div variants={itemVariants}>
        <NavLink
          to="/latest-news"
          className="inline-flex items-center gap-2 py-3 px-6 rounded-[37px] border border-[#1B1F24] font-halyard text-[14px] font-normal tracking-[2px] uppercase text-[#1B1F24] transition-colors duration-200 hover:bg-[#1B1F24] hover:text-[#F7F4F0]"
        >
          Back to News
        </NavLink>
      </motion.div>
    </motion.div>
  )
}
